import { useTRPC } from "../../../../trpc/client";
import { useMerchant } from "../../../../hooks/useMerchant";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export function useCreateWithdrawal(
  onSuccess?: () => void,
  onError?: (error: unknown) => void
) {
  const trpc = useTRPC();
  const { merchant } = useMerchant();
  const queryClient = useQueryClient();

  const createWithdrawalMutation = useMutation({
    ...trpc.withdrawals.create.mutationOptions(),
    onSuccess,
    onError,
  });

  const createWithdrawal = (amount: number) => {
    if (!merchant?.id) return;

    createWithdrawalMutation.mutate(
      { rentalsMerchantId: merchant.id, amount },
      {
        onSuccess: () => {
          queryClient.invalidateQueries({
            queryKey: trpc.withdrawals.list.queryKey(),
          });
          queryClient.invalidateQueries({
            queryKey: trpc.ledgerMovements.getBalance.queryKey(),
          });
        },
      }
    );
  };

  return { createWithdrawal, isCreating: createWithdrawalMutation.isPending };
}
